var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-card",
    { staticClass: "elevation-12 rounded-t-0" },
    [
      _c(
        "v-card-text",
        [
          _vm.localLoginEnabled
            ? _c(
                "v-form",
                {
                  ref: "form",
                  attrs: { id: "login_form", name: "login_form" },
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.login.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("v-text-field", {
                    attrs: {
                      id: "email_field",
                      "error-messages": _vm.emailErrors(_vm.$v.email),
                      name: "email",
                      label: "Email",
                      "prepend-icon": "mdi-at",
                      type: "text",
                      required: "",
                      tabindex: "1",
                    },
                    on: {
                      blur: function ($event) {
                        return _vm.$v.email.$touch()
                      },
                    },
                    model: {
                      value: _vm.email,
                      callback: function ($$v) {
                        _vm.email = $$v
                      },
                      expression: "email",
                    },
                  }),
                  _c("v-text-field", {
                    ref: "password",
                    attrs: {
                      id: "password_field",
                      "error-messages": _vm.requiredFieldError(
                        _vm.$v.password,
                        "Password"
                      ),
                      type: _vm.showPassword ? "text" : "password",
                      name: "password",
                      label: "Password",
                      "prepend-icon": "mdi-lock",
                      tabindex: "2",
                    },
                    on: {
                      blur: function ($event) {
                        return _vm.$v.password.$touch()
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "append",
                          fn: function () {
                            return [
                              _c(
                                "v-icon",
                                {
                                  on: {
                                    click: function ($event) {
                                      _vm.showPassword = !_vm.showPassword
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.showPassword
                                          ? "mdi-eye"
                                          : "mdi-eye-off"
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      1203299312
                    ),
                    model: {
                      value: _vm.password,
                      callback: function ($$v) {
                        _vm.password = $$v
                      },
                      expression: "password",
                    },
                  }),
                  _c(
                    "v-container",
                    { staticClass: "mb-0", attrs: { fluid: "" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            id: "login_button",
                            depressed: "",
                            large: "",
                            color: "primary",
                            disabled: _vm.$v.$invalid,
                            type: "submit",
                            tabindex: "3",
                            loading: _vm.buttonLoading,
                          },
                        },
                        [_vm._v(" Login ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _c(
                "v-banner",
                [
                  _c(
                    "v-layout",
                    [
                      _vm._v(
                        " NOTE: This Heimdall instance is in an external-authentication only mode. "
                      ),
                      _c(
                        "v-icon",
                        {
                          staticClass: "mr-3",
                          on: { click: _vm.openExternalAuthModeDocumentation },
                        },
                        [_vm._v("mdi-help-circle-outline")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
        ],
        1
      ),
      _c(
        "v-card-actions",
        [
          _c(
            "v-container",
            { attrs: { fluid: "" } },
            [
              _vm.registrationEnabled && _vm.localLoginEnabled
                ? _c(
                    "div",
                    { staticClass: "d-flex align-end flex-column mb-2" },
                    [
                      _c(
                        "router-link",
                        { attrs: { to: "/signup" } },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                id: "sign_up_button",
                                depressed: "",
                                small: "",
                              },
                            },
                            [_vm._v(" Sign Up ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c("v-spacer"),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showAlternateAuth,
                      expression: "showAlternateAuth",
                    },
                  ],
                },
                [
                  _vm.localLoginEnabled
                    ? _c(
                        "v-row",
                        { attrs: { align: "center" } },
                        [_c("v-divider"), _vm._v("OR"), _c("v-divider")],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "d-flex justify-content-center flex-wrap" },
                    [
                      _vm.authStrategySupported("oidc")
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "mt-5 flex-fill",
                              attrs: { id: "oauth-oidc", plain: "" },
                              on: {
                                click: function ($event) {
                                  return _vm.oauthLogin("oidc")
                                },
                              },
                            },
                            [
                              _c("v-img", {
                                attrs: {
                                  "max-width": "32",
                                  "max-height": "32",
                                  src: require("@/assets/openid_mark.png"),
                                },
                              }),
                              _c("div", { staticClass: "pl-2" }, [
                                _vm._v("Login with " + _vm._s(_vm.oidcName)),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "v-btn",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.authStrategySupported("google"),
                              expression: "authStrategySupported('google')",
                            },
                          ],
                          staticClass: "mt-5 flex-fill",
                          attrs: { id: "oauth-google", plain: "" },
                          on: {
                            click: function ($event) {
                              return _vm.oauthLogin("google")
                            },
                          },
                        },
                        [
                          _c("v-img", {
                            attrs: {
                              "max-width": "32",
                              "max-height": "32",
                              src: require("@/assets/google_mark.png"),
                            },
                          }),
                          _c("div", { staticClass: "pl-2" }, [
                            _vm._v("Login with Google"),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "v-btn",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.authStrategySupported("github"),
                              expression: "authStrategySupported('github')",
                            },
                          ],
                          staticClass: "mt-5 flex-fill",
                          attrs: { id: "oauth-github", plain: "" },
                          on: {
                            click: function ($event) {
                              return _vm.oauthLogin("github")
                            },
                          },
                        },
                        [
                          _c("v-img", {
                            attrs: {
                              "max-width": "32",
                              "max-height": "32",
                              src: require("@/assets/github_mark.png"),
                            },
                          }),
                          _c("div", { staticClass: "pl-2" }, [
                            _vm._v("Login with GitHub"),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "v-btn",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.authStrategySupported("gitlab"),
                              expression: "authStrategySupported('gitlab')",
                            },
                          ],
                          staticClass: "mt-5 flex-fill",
                          attrs: { id: "oauth-gitlab", plain: "" },
                          on: {
                            click: function ($event) {
                              return _vm.oauthLogin("gitlab")
                            },
                          },
                        },
                        [
                          _c("v-img", {
                            attrs: {
                              "max-width": "32",
                              "max-height": "32",
                              src: require("@/assets/gitlab_mark.png"),
                            },
                          }),
                          _c("div", { staticClass: "pl-2" }, [
                            _vm._v("Login with GitLab"),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "v-btn",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.authStrategySupported("okta"),
                              expression: "authStrategySupported('okta')",
                            },
                          ],
                          staticClass: "mt-5 flex-fill",
                          attrs: { id: "oauth-okta", plain: "" },
                          on: {
                            click: function ($event) {
                              return _vm.oauthLogin("okta")
                            },
                          },
                        },
                        [
                          _c("v-img", {
                            attrs: {
                              "max-width": "32",
                              "max-height": "32",
                              src: require("@/assets/okta_mark.png"),
                            },
                          }),
                          _c("div", { staticClass: "pl-2" }, [
                            _vm._v("Login with Okta"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }